// extracted by mini-css-extract-plugin
export default {"body":"Input_body__nrw2r","label":"Input_label__VvTAB","input":"Input_input__KYb9N","input--dynamic-label":"Input_input--dynamic-label__YQUhz"};